<template>
  <div class="page">
    <Frame class="page-frame">
      <template v-slot:header>
        <div class="header">
          <div class="search-box">
            <div class="left">
              <van-search
                v-model="searchValue"
                shape="round"
                placeholder="请输入搜索关键词"
                @search="searchEvt"
              />
            </div>
            <div class="right">
              <van-icon
                size="24px"
                :name="require('@/assets/image/common/filter.png')"
                @click="showFilterDialog"
              />
            </div>
          </div>
          <div class="nav-box">
            <TabToggle
              default-id="pending"
              :list="tabList"
              @onChange="onChangeTab"
            />
          </div>
        </div>
      </template>
      <template v-slot:body>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model:loading="loading"
            :finished="finished"
            :finished-text="
              finished && list.length >= total && list.length > 0
                ? '--没有更多了--'
                : ''
            "

          >
            <!-- @load="onLoad"  -->
            <TodoItem
              :RUserId="RUserId"
              :detail="item"
              :key="item"
              v-for="item in list"
            />
            <van-empty
              v-if="list.length <= 0 && finished"
              class="custom-image"
              :image="require('@/assets/image/no-data.png')"
              description="暂无数据"
            />
          </van-list>
        </van-pull-refresh>
        <FilterDialog
          title="筛选"
          v-if="isShowDialog"
          @right="onCancleEvt"
          @ok="dialogOkEvt"
          @reset="dialogResetEvt"
        >
          <div class="filter-content">
            <FilterStatusList
              ref="statusListRef"
              :default-ids="statusListSelected"
              :list="statusList"
            />
            <FilterStatusList
              ref="applyTypesRef"
              title="申请"
              :default-ids="applyTypesSelected"
              :list="applyTypes"
            />
          </div>
        </FilterDialog>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "@/components/frame.vue";
import TabToggle from "./components/tabToggle.vue";
import TodoItem from "./components/todoItem.vue";
import FilterDialog from "@/components/filterDialog.vue";
import FilterStatusList from "@/components/filterStatusList.vue";
import { Toast } from "vant";
import { ref, computed ,onMounted} from "vue";

import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  name: "TodoList",
  components: {
    Frame,
    TabToggle,
    TodoItem,
    FilterDialog,
    FilterStatusList,
  },

  setup() {
   
            onMounted(() => {
              getPendingList()
            })

    const route = useRoute();
    document.title = route.meta.title;

    const store = useStore();

    const RUserId = ref(computed(() => store.state.userId));

    const searchValue = ref("");
    const searchEvt = () => {
      list.value = [];
      pageIndex = 1;
      getPendingList();
    };

    // 筛选状态列表
    let statusListRef = ref(null);
    const statusListSelected = ref([]);
    const statusList = ref([]);
    const workflowStatusList = (params) =>
      store.dispatch("msgCenter/workflowStatusList", params);
    const getStatusList = async () => {
      let r = await workflowStatusList();
      if (r.message === "success") {
        let list = r.data.list;
        list.map((item) => {
          let temp = {
            name: item.name,
            value: item.code,
          };
          statusList.value.push(temp);
        });
      } else {
        Toast.fail(r.message);
      }
    };
    getStatusList();

    // 申请类型列表
    const applyTypesRef = ref(null);
    const applyTypesSelected = ref([]);
    const applyTypes = ref([]);
    const workflowModuleList = (params) =>
      store.dispatch("msgCenter/workflowModuleList", params);
    const getApplyTypes = async () => {
      let r = await workflowModuleList();
      if (r.message === "success") {
        let list = r.data.list;
        list.map((item) => {
          let temp = {
            name: item.name,
            value: item.code,
          };
          applyTypes.value.push(temp);
        });
      } else {
        Toast.fail(r.message);
      }
    };
    getApplyTypes();
    let pageIndex = 1;
    let pageSize = 30;
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const list = ref([]);
    const total = ref(0);
    // const onLoad = () => {
    //   getPendingList();
    // };

    const onRefresh = () => {
      // 清空列表数据
      list.value = [];
      pageIndex = 1;
      finished.value = false;
    };
    const pendingList = (params) =>
      store.dispatch("msgCenter/pendingList", params);


    const getPendingList = async () => {
      let params = {
        bizTypeList: applyTypesSelected.value, // 业务类型 []
        operateType: operateType.value,
        pageNo: pageIndex,
        pageSize: pageSize,
        searchName: searchValue.value,
        searchStatusList: statusListSelected.value,
      };

      setTimeout(() => {
        loading.value = false;
        finished.value = true;
      }, 3000);
      let r = await pendingList(params);
      if (r.message == "success") {
        if (refreshing.value) {
          list.value = [];
          refreshing.value = false;
        }
        list.value.push(...r.data.list);
        loading.value = false;
        pageIndex++;
        total.value = r.data.total;
        if (list.value.length >= r.data.total) {
          finished.value = true;
        }
      } else {
        refreshing.value = false;
        finished.value = true;
        loading.value = false;
        Toast.fail(r.message);
      }
    };

    const operateType = ref("pending");
    const tabList = ref([
      {
        name: "待处理",
        id: "pending",
        isTag: false,
        number: 0,
      },
      {
        name: "已处理",
        id: "processed",
        isTag: false,
      },
      {
        name: "抄送我",
        id: "cc",
        isTag: false,
        // number: 0,
      },
      {
        name: "我发起的",
        id: "initiator",
        isTag: false,
      },
    ]);
    const onChangeTab = (item) => {
      operateType.value = item.id;
      applyTypesSelected.value = [];
      statusListSelected.value = [];
      list.value = [];
      pageIndex = 1;
      getPendingList();
    };
    // 待办中待处理数量和抄送未读数量
    const workflowPendingInfo = (params) =>
      store.dispatch("msgCenter/workflowPendingInfo", params);
    const getWorkflowPendingInfo = async () => {
      let r = await workflowPendingInfo();
      if (r.message === "success") {
        let { isExistPending, isReadCc, pendingNumber } = r.data;
        tabList.value[0].isTag = isExistPending;
        tabList.value[0].number = pendingNumber;
        tabList.value[2].isTag = isReadCc;
      } else {
        Toast.fail(r.message);
      }
    };
    getWorkflowPendingInfo();

    const isShowDialog = ref(false);
    const showFilterDialog = () => {
      isShowDialog.value = true;
    };
    const onCancleEvt = () => {
      isShowDialog.value = false;
    };
    const dialogOkEvt = () => {
      statusListSelected.value = statusListRef.value.activeIds;
      applyTypesSelected.value = applyTypesRef.value.activeIds;
      console.log("ddddd",applyTypesSelected.value)

      list.value = [];
      pageIndex = 1;
      getPendingList();

      isShowDialog.value = false;
    };
    const dialogResetEvt = () => {
      statusListRef.value.resetEvt();
      applyTypesRef.value.resetEvt();
    };

    return {
      RUserId,
      searchEvt,
      tabList,
      onChangeTab,
      statusListRef,
      statusList,
      applyTypesRef,
      applyTypes,
      searchValue,
      statusListSelected,
      applyTypesSelected,
      list,
      isShowDialog,
      showFilterDialog,
      onCancleEvt,
      dialogOkEvt,
      dialogResetEvt,
      loading,
      finished,
      total,
      refreshing,
      // onLoad,
      onRefresh,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
}
.page-frame {
  height: 100vh;
}
.header {
  .search-box {
    display: flex;
    align-items: center;
    background-color: #fff;
    .left {
      flex: 1;
    }
    .right {
      width: 63px;
      text-align: center;
    }
  }
}
.filter-content {
  padding: 10px 0;
}
</style>
